<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill *ngIf="currDate">

  <!-- Text -->
  <div class="text-center p-4">
    <div class="text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins">
      {{'selectproductstimeslotComponent.orderPlan'|translate}}
    </div>
  </div>

  <!-- Date && hours -->
  <div class="px-4 flex flex-col">
    <div class="full-w">
      <p *ngIf="setFirstMinDate && !closedForToday">
        {{'selectproductstimeslotComponent.nextslot'|translate}}
      <p>
      <p *ngIf="closedForToday">
        {{'selectproductstimeslotComponent.unavailableslot'|translate}}
      </p>
    </div>

    <mat-form-field appearance="outline" class="input-height form-nopadd"
      *ngIf="timetables.length > 0 && !loaders.dates ">
      <div class="full-screen clicked" style="position: absolute; top: 0;"
        (click)="daysClosedLoaded && picker1.open();"></div>
      <input matInput [matDatepicker]="picker1" [matDatepickerFilter]="filterDate" [min]="minDate"
        (dateChange)="setDate()" placeholder="Date" [(ngModel)]="currDate" [disabled]="!daysClosedLoaded">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker touchUi #picker1 disabled="false" angularticsAction="selectDate" angularticsCategory="order">
      </mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="input-height form-nopadd"
      *ngIf="timetables.length < 1 && !loaders.dates ">
      <input matInput [matDatepicker]="picker1" [matDatepickerFilter]="filterDate" [min]="minDate"
        (dateChange)="setDate()" placeholder="Date" [(ngModel)]="currDate" disabled>
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>

    <!-- Hours -->
    <mat-form-field appearance="outline" class="input-height form-nopadd" *ngIf="!closedForToday && !loaders.hours"
      id="hourorder" angulartics2On="click" angularticsAction="selectHour" angularticsCategory="productsTimeSlot">
      <mat-select [disabled]="!currDate || timetables.length < 1" placeholder="{{'HOUR'|translate}}"
        [(ngModel)]="currHour">
        <mat-option *ngFor="let hour of currHours" [value]="hour.hour" [disabled]="!hour.available">
          <div fxLayoutAlign="space-between">
            <span>{{hour.hour}} - {{hour.hour_end}}</span>
            <span class="warn-ico" *ngIf="!hour.available"> {{'selectproductstimeslotComponent.unavailable'|translate}}
            </span>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Loader -->
    <div fxLayout="column" fxLayoutAlign="center center" class="text-center" style="height: 65px;"
      *ngIf="loaders.dates">
      <span class="mat-caption">{{'selectproductstimeslotComponent.getDate'|translate}} </span>
      <mat-progress-bar diameter="20" mode="indeterminate"></mat-progress-bar>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="text-center" style="height: 65px;"
      *ngIf="loaders.hours">
      <span class="mat-caption">{{'selectproductstimeslotComponent.getSlot'|translate}}</span>
      <mat-progress-bar diameter="20" mode="indeterminate"></mat-progress-bar>
    </div>
    <div *ngIf="gapNeeded && saleMethod.limit_order_gap_str && saleMethod.limit_order_gap_str>0 ">
      <span class="mat-caption">{{'selectproductstimeslotComponent.minTime'|translate}}
        <strong>{{saleMethod.limit_order_gap_str}}</strong></span>
    </div>
  </div>

  <!-- Buttons -->
  <div class="flex flex-col gap-2.5 p-4">
    <button [ngClass]="cssService.defaultPositiveDialogButton" [disabled]="!currDate || !currHour"
      (click)="closeDial(true)">{{"button.validate" | translate}}</button>
    <button [ngClass]="cssService.defaultNegativeDialogButton" (click)="closeDial(false)">{{"dialogs.go-back" |
      translate}}</button>
  </div>
  <app-popup-loader [flagLoading]="loaders.page" [size]="30">
  </app-popup-loader>
</div>

<div *ngIf="closedForToday" fxLayout="column" fxLayoutGap="25px" fxLayoutAlign="center center"
  style="height: 200px;width: 200px;" class="layout-padd text-center full-w">
  <div class="  full-w">{{'selectproductstimeslotComponent.slotUnavaible'|translate}}</div>
  <div>{{'selectproductstimeslotComponent.cancel'|translate}}</div>
</div>